import createMuiTheme from "@material-ui/core/styles/createTheme";
import {IMAGE_PATHS} from "../../constants/ImagePathConstants";

//extend the Material UI default theme
declare module '@material-ui/core/styles/createTheme' {
    interface Theme {
        domainLogo: {
            url: string
        }
    }
}

const options = {
    CargoPartnerOptions: {
        domainLogo: {
            url: IMAGE_PATHS.CP_LOGO,
        },
        palette: {
            primary: {
                main: '#006EB6',
                light: '#338bc4',
                dark: '#004d7f',
                contrastText: '#fff',
            },
            secondary: {
                main: '#43a047',
                light: '#68b36b',
                dark: '#2e7031',
                contrastText: '#fff',
            },
        }
    },
    ABCOptions: {
        domainLogo: {
            url: IMAGE_PATHS.ABC_LOGO,
        },
        palette: {
            primary: {
                main: '#a70d07',
                light: '#b83d38',
                dark: '#740904',
                contrastText: '#fff',
            },
            secondary: {
                main: '#43a047',
                light: '#68b36b',
                dark: '#2e7031',
                contrastText: '#fff',
            },
        }
    },
    VCPOptions: {
        domainLogo: {
            url: IMAGE_PATHS.VCP_LOGO,
        },
        palette: {
            primary: {
                main: '#006EB6',
                light: '#338bc4',
                dark: '#004d7f',
                contrastText: '#fff',
            },
            secondary: {
                main: '#43a047',
                light: '#68b36b',
                dark: '#2e7031',
                contrastText: '#fff',
            },
        }
    }
};
export const CargoPartnerTheme = createMuiTheme(options.CargoPartnerOptions);
export const ABCTheme = createMuiTheme(options.ABCOptions);
export const VCPTheme = createMuiTheme(options.VCPOptions);